import tenantUtils from '@utils';
import { t } from 'i18next';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { DrawerModal } from '../../../../components/common';
import { regaQRCodeClickEvent } from '../../../../services/analyticsService';
import { formatNumberString } from '../../../../utility/utility';
import RegaDetailFields from './RegaDetailFields';
import RegaDetailBand from './RegaDetailBand';

const ListingDetailModal = ({ setModalVisible, visible, listing }) => {
  const { user } = useSelector((state) => state.app.loginUser);
  const rega = listing?.rega_details;
  const specs = rega?.property_specs;

  const typeLabel = useMemo(
    () =>
      [
        tenantUtils.getLocalisedString(specs, 'listing_type'),
        tenantUtils.getLocalisedString(specs, 'advertisement_type'),
      ]
        .filter(Boolean)
        .join(' '),
    [specs],
  );

  const location = useMemo(
    () =>
      [rega?.location?.district, rega?.location?.city, tenantUtils.getLocalisedString(rega?.location, 'region')]
        .filter(Boolean)
        .join(', '),
    [rega?.location],
  );

  const price = listing?.price ? formatNumberString(listing.price, { maximumFractionDigits: 0 }) : null;
  const area = specs?.area_size;
  const adLicense = rega?.license_info?.ad_license_number;
  const url = rega?.url;

  return (
    <DrawerModal
      visible={visible}
      onCancel={() => setModalVisible(false)}
      title={t('Listing Details from REGA')}
      width="880px"
      styles={{
        body: { maxHeight: 608, overflowY: 'auto', padding: 0 },
        content: { borderRadius: 12, overflow: 'hidden', padding: 0 },
      }}
      footer={null}
      height="664px"
    >
      <RegaDetailBand
        typeLabel={typeLabel}
        price={price}
        adLicense={adLicense}
        location={location}
        area={area}
        url={url}
        onRegaClick={(isQr) => regaQRCodeClickEvent(user, isQr, rega?.license_info)}
      />

      <div style={{ padding: '16px 0 8px' }}>
        <RegaDetailFields listing={listing} />
      </div>
    </DrawerModal>
  );
};

export default ListingDetailModal;
